import React, { useState, useEffect } from 'react';

import { Button } from '@mui/material';
import { CloseIconButton } from '../../ButtonsIconsInputs/IconButtons';
import Heading from '../reusableComp/Heading';
import { CustomSelect, InputBox } from '../../ButtonsIconsInputs/CustomInputs';

function EditSkillModal({ Data, handleClose, setStatus, IsSuperAdmin, setRecenteditFormData }) {
    const [message, setMessage] = useState('');
    const [updating, setUpdating] = useState(false); // Added updating state
    const api_url = process.env.REACT_APP_API_URL
    const [formData, setFormData] = useState({
        JobroleId: '',
        jobroleName: '',
        jobroleDescription: '',
        IsReserved: 0
    });

    
    useEffect(() => {
        if (Data) {
            setFormData({
                jobroleId: Data.jobroleId,
                jobroleName: Data.jobroleName,
                jobroleDescription: Data.jobroleDescription,
                IsReserved: Data.IsReserved
            });
        }
    }, [Data]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
                sendDataToServer(formData);
    };

    const sendDataToServer = async (formData) => {
        setUpdating(true); // Set updating to true when starting the update
        const res = await fetch(`${api_url}/jobroles/update`, {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData)
        });

        const result = await res.json();
                setMessage(result.message);
        if (res.ok) {
                        setStatus(true);
            setRecenteditFormData(formData);
            handleClose();
        } else {
                    }
        setUpdating(false); // Set updating to false after the update is complete
    };

    return (
        <div className='modal-overlay'>
            {Data.IsReserved} AND {IsSuperAdmin}
            <div className='bg-white w-5/6 md:w-2/3 lg:w-1/2 xl:w-1/3 rounded-md'>
                <div className='flex justify-between rounded-t-md items-center mb-8 bg-sky-600 w-full text-gray-50 py-3 px-4'>
                    <div className='invisible'>content</div>
                    <Heading heading={"Edit Job Role"} />

                    <div className='self-center'>
                        <CloseIconButton action={handleClose} />
                    </div>
                </div>
                <form className='flex flex-col gap-10 px-5 mb-5' onSubmit={handleSubmit}>
                    <div className='flex flex-col'>
                        <InputBox
                            inputLabel='Jobrole'
                            required='true'
                            inputId='jobrole'
                            type='text'
                            inputName='jobroleName'
                            onChange={handleChange}
                            inputValue={formData.jobroleName}
                        />
                    </div>
                    {IsSuperAdmin && (<div className='flex flex-col'>
                        <CustomSelect
                            inputId='IsReserved'
                            options={[{ value: 1, label: 'yes' }, { value: 2, label: 'no' }]}  // options array
                            dataField='value'   // Key for the option value
                            dataText='label'    // Correct the key from 'lable' to 'label' for displaying text
                            label='IsReserved'  // Label for the select input
                            name='IsReserved'   // Name of the input field
                            onChange={(e) => handleChange(e)}  // Change event handler
                            value={formData.IsReserved}  // Current value from formData
                        />
                    </div>)}
                    <div className='flex flex-col'>
                        <InputBox
                            inputLabel='Desc'
                            type='text'
                            inputId='jobroledesc'
                            inputName='jobroleDescription'
                            onChange={handleChange}
                            inputValue={formData.jobroleDescription}
                        />
                    </div>

                    {message && <div className='text-yellow-300'>{message}</div>}
                    <Button sx={{ textTransform: 'none' }} id='Edit-Jobrole-submit' variant='contained' type='submit' disabled={updating}>
                        {updating ? 'Updating...' : 'Update jobrole'}
                    </Button>
                </form>
            </div>
        </div >
    );
}

export default EditSkillModal;
